import React from 'react';
import constants from '../../common/constants';
import { Button } from '@amzn/awsui-components-core';

interface Props {
  isFileUploading: boolean;
  handleFileUpload: (file: any) => void;
  acceptanceType?: string;
  customButtonText?: string;
}

class FileUpload extends React.Component<Props> {
  private attachmentUpload: HTMLInputElement | null = null;

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
  }

  public render() {
    const { customButtonText, isFileUploading, acceptanceType } = this.props;
    const buttonText = customButtonText ? customButtonText : constants.UPLOAD_BUTTON_TEXT;
    return (
      <div>
        <input
          id={'attachmentUpload'}
          className={'attachment-upload-input'}
          type="file"
          ref={(ref) => {
            this.attachmentUpload = ref;
          }}
          onChange={this.selectFileHandler}
          accept={acceptanceType}
        />
        <span>
          <Button loading={isFileUploading} onClick={this.handleFileUploadClick} iconName="upload">
            {buttonText}
          </Button>
        </span>
      </div>
    );
  }

  private handleFileUploadClick = (e: any) => {
    this.attachmentUpload?.click();
  };

  private selectFileHandler = (e: any) => {
    e.preventDefault();
    const handleFileUpload = this.props.handleFileUpload;
    const file = e.target.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };
}

export default FileUpload;
